/**
 * Browser language → Shopify locale (fr if browser prefers French, else en).
 * Manual choice via the navbar localization form is stored and always wins.
 *
 * SEO rules (sept. 2026):
 *  - never runs for search-engine / social crawlers, so Google indexes each
 *    language on its own URL (/ and /fr/) instead of being bounced;
 *  - only auto-switches a visitor who lands on the default (English) URL.
 *    Someone who opens a /fr/ link (e.g. from Google.fr) stays in French.
 */
(function () {
  'use strict';

  var MANUAL_KEY = 'tedco_locale_manual';
  var SWITCH_KEY = 'tedco_locale_switching';

  function currentLocale() {
    var lang = document.documentElement.getAttribute('lang') || 'en';
    return String(lang).slice(0, 2).toLowerCase();
  }

  function preferredFromBrowser() {
    var list =
      navigator.languages && navigator.languages.length
        ? navigator.languages
        : [navigator.language || navigator.userLanguage || 'en'];
    for (var i = 0; i < list.length; i += 1) {
      if (String(list[i] || '')
        .toLowerCase()
        .indexOf('fr') === 0) {
        return 'fr';
      }
    }
    return 'en';
  }

  function findLocaleForm() {
    return (
      document.querySelector('.locale-menu form') ||
      document.querySelector('form[action*="/localization"]') ||
      document.querySelector('form.xo-language-select__form')
    );
  }

  function optionExists(select, code) {
    if (!select) return false;
    var want = String(code).toLowerCase();
    for (var i = 0; i < select.options.length; i += 1) {
      if (String(select.options[i].value).toLowerCase().slice(0, 2) === want) {
        return select.options[i].value;
      }
    }
    return null;
  }

  function switchTo(code) {
    var form = findLocaleForm();
    if (!form) return false;
    var select = form.querySelector('[name="locale_code"]');
    var value = optionExists(select, code);
    if (!value) return false;
    if (String(value).toLowerCase().slice(0, 2) === currentLocale()) return false;

    try {
      sessionStorage.setItem(SWITCH_KEY, '1');
    } catch (e) {}

    select.value = value;
    if (typeof form.requestSubmit === 'function') form.requestSubmit();
    else form.submit();
    return true;
  }

  function bindManualForms() {
    document.querySelectorAll('form').forEach(function (form) {
      var select = form.querySelector('[name="locale_code"]');
      if (!select) return;
      form.addEventListener('submit', function () {
        var raw = select.value || '';
        var code = String(raw).slice(0, 2).toLowerCase();
        if (!code) return;
        try {
          localStorage.setItem(MANUAL_KEY, code);
        } catch (e) {}
      });
    });
  }

  function isBot() {
    var ua = String(navigator.userAgent || '');
    return (
      navigator.webdriver === true ||
      /bot|crawl|spider|slurp|mediapartners|google|bing|yandex|baidu|duckduck|facebookexternalhit|embedly|quora|pinterest|lighthouse|headless|chrome-lighthouse|gptbot|claude|perplexity|applebot/i.test(ua)
    );
  }

  function run() {
    bindManualForms();
    if (isBot()) return;

    try {
      if (sessionStorage.getItem(SWITCH_KEY)) {
        sessionStorage.removeItem(SWITCH_KEY);
        return;
      }
    } catch (e) {}

    var current = currentLocale();
    var manual = null;
    try {
      manual = localStorage.getItem(MANUAL_KEY);
    } catch (e) {}

    if (manual) {
      manual = String(manual).slice(0, 2).toLowerCase();
      if (manual !== current) switchTo(manual);
      return;
    }

    // Automatic detection only from the default-language URL.
    var defaultLang = 'en';
    if (current !== defaultLang) return;
    var want = preferredFromBrowser();
    if (want !== current) switchTo(want);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
